import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-confirm",
  "use": "rt-portal-confirm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-confirm\"><defs><style type=\"text/css\"></style></defs><path d=\"M382.2 925.5h-272v-832h800v416h-64v-352h-672v704h208z\" p-id=\"4460\" /><path d=\"M610.3 943.8L451.9 785.4l45.3-45.3 113.1 113.2 248.9-248.9 45.2 45.2zM302.2 333.5h416v64h-416zM303.1 502.7h224v64h-224z\" p-id=\"4461\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/confirm.svg
// module id = 688
// module chunks = 99